import { render } from "./errorLogNew.vue?vue&type=template&id=494123b4&scoped=true"
import script from "./errorLogNew.vue?vue&type=script&lang=js"
export * from "./errorLogNew.vue?vue&type=script&lang=js"

import "./errorLogNew.vue?vue&type=style&index=0&id=494123b4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494123b4"]])

export default __exports__